import { render } from "./ball.widget.vue?vue&type=template&id=270d05c4"
import script from "./ball.widget.vue?vue&type=script&lang=js"
export * from "./ball.widget.vue?vue&type=script&lang=js"

import "./ball.widget.vue?vue&type=style&index=0&id=270d05c4&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/miyo-prod/ftrc-prd/src/project/fotile-riskctl/code/frontend/mgr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__